import refaqLogo from "../assets/refaq-logo.png";

export { refaqLogo };

// Display the lettering within the original PNG's transparent canvas.
// The source image stays unchanged; both screen and print use the same framing.
export const refaqLogoCss = `
  .refaq-logo-frame { position:relative; width:180px; max-width:100%; aspect-ratio:1145 / 280; overflow:hidden; background:transparent; }
  .refaq-logo-frame img { position:absolute; width:136.50655%; max-width:none; height:auto; left:-19.213974%; top:-261.071429%; }
`;
